import { Component } from '@angular/core';

@Component({
  selector: 'smhfs-fe-branding',
  template: `
    <a class="matero-branding" href="/">
      <img src="./assets/images/matero.png" class="matero-branding-logo-expanded" alt="logo" />
      <span class="matero-branding-name">MATERO</span>
    </a>
  `,
})
export class BrandingComponent {}
